// extracted by mini-css-extract-plugin
module.exports = {"root":"SectionFaqs_root__1Ipey","title":"SectionFaqs_title__dkfNn","description":"SectionFaqs_description__34E3d","link":"SectionFaqs_link__bSpiW"};